<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/products/consumer-market',
    'fr-CA': '/produits/marche-de-consommation'
  }
})

useHead({
  title: t('navigation.consumerMarket.metatitle'),
  meta: [{ name: 'description', content: t('navigation.consumerMarket.metadescription') }],
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('products-products')">{{ $t('navigation.products.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.consumerMarket.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.consumerMarket.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuProducts />
        <div class="contenu right">
          <div class=""
               v-if="$i18n.locale == 'en-CA'">
            <p>In the Canadian consumer business, the Company primarily sells branded products such as bathroom tissue, facial tissue, paper towels and napkins. These products are marketed under a number of trademarks, including Cashmere, Purex, Scotties, SpongeTowels, White Swan and Bonterra, all of which are owned except for Scotties, which is under a long-term license. In the U.S. the Company sells branded products under the White Cloud trademark. For the year ended December 31, 2021, the consumer business represented approximately 86% of total consolidated revenue.</p>
            <p><a class="btn"
                 href="http://www.krugerproducts.ca"
                 target="_blank">Consumer website</a></p>
            <div class="N2d6b3d6637bf48dd9c8af529a6ab7feb logoMarque">
              <div class="unLogo">
                <span><a href="http://www.cashmere.ca/#home"
                     target="_blank"><img src="~/assets/images/cashmere-logo.png"
                         alt="Cashmere"></a></span>
              </div>
              <div class="unLogo">
                <span><a href="http://scotties.ca/en/"
                     target="_blank"><img src="~/assets/images/scotties-logo-2021.jpg"
                         alt="scotties-logo-2021"></a></span>
              </div>
              <div class="unLogo">
                <span><a href="http://www.purex.ca"
                     target="_blank"><img src="~/assets/images/purex-logo.png"
                         alt="Purex"></a></span>
              </div>
              <div class="unLogo">
                <span><a href="http://www.whiteswan.ca"
                     target="_blank"><img src="~/assets/images/whiteswan.png"
                         alt="WhiteSwan"></a></span>
              </div>
              <div class="unLogo">
                <span><a href="http://www.spongetowels.ca"
                     target="_blank"><img src="~/assets/images/spongetowels-logo-2021.jpg"
                         alt="spongetowels-logo-2021"></a></span>
              </div>
              <div class="unLogo">
                <span><a href="http://www.mywhitecloud.com/"
                     target="_blank"><img src="~/assets/images/whitecloud-2021.png"
                         alt="whiteCloud"></a></span>
              </div>
              <div class="unLogo">
                <span><a href="https://livebonterra.com/en"
                     target="_blank"><img src="~/assets/images/bonterra-logo.jpg"
                         alt="Bonterra"></a></span>
              </div>
            </div>
          </div>
          <div class=""
               v-if="$i18n.locale == 'fr-CA'">
            <p>Dans le segment du marché de consommation canadien, la Société vend principalement des produits (papier hygiénique, papiers-mouchoirs, essuie-tout et serviettes de table) commercialisés sous de nombreuses marques, notamment Cashmere<sup>MD</sup>, Purex<sup>MD</sup>, Scotties<sup>MD</sup>, SpongeTowels<sup>MD</sup>&nbsp;,White Swan<sup>MD</sup>&nbsp;et Bonterra<sup>MD</sup>, qui lui appartiennent toutes, sauf Scotties<sup>MD</sup>, dont elle est une usagère autorisée en vertu d'une licence à long terme. Aux États-Unis, elle vend des produits de marque White Cloud<sup>MD</sup>. Au terme de l'exercice clos le 31 décembre 2021, le segment du marché de consommation représentait environ 86&nbsp;% des produits d'exploitation consolidés de la Société.</p>
            <p><a class="btn"
                 href="http://www.krugerproducts.ca"
                 target="_blank">Site web pour consommateur</a></p>
            <div class="logoMarque">
              <div class="unLogo">
                <span><a href="http://www.cashmere.ca/index_fr.html#home"
                     target="_blank"><img src="~/assets/images/cashmere-logo.png"
                         alt="Cashmere"></a></span>
              </div>
              <div class="unLogo">
                <span><a href="http://scotties.ca/fr/"
                     target="_blank"><img src="~/assets/images/scotties-logo-2021.jpg"
                         alt="scotties-logo-2021"></a></span>
              </div>
              <div class="unLogo">
                <span><a href="http://purex.ca/fr"
                     target="_blank"><img src="~/assets/images/purex-logo.png"
                         alt="Purex"></a></span>
              </div>
              <div class="unLogo">
                <span><a href="http://www.whiteswan.ca/francais.html"
                     target="_blank"><img src="~/assets/images/whiteswan.png"
                         alt="WhiteSwan"></a></span>
              </div>
              <div class="unLogo">
                <span><a href="http://www.spongetowels.ca/index-fr.php"
                     target="_blank"><img src="~/assets/images/spongetowels-logo-2021.jpg"
                         alt="spongetowels-logo-2021"></a></span>
              </div>
              <div class="unLogo">
                <span><a href="http://www.mywhitecloud.com/"
                     target="_blank"><img src="~/assets/images/whitecloud-2021.png"
                         alt="whiteCloud"></a></span>
              </div>
              <div class="unLogo">
                <span><a href="https://livebonterra.com/fr"
                     target="_blank"><img src="~/assets/images/bonterra-logo.jpg"
                         alt="Bonterra"></a></span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
